import { defer, Observable, of } from 'rxjs';
import { mergeMap, withLatestFrom } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { EpicDeps } from 'src/core/engine';
import { catchableUnauthenticated } from 'src/core/state/user';
import { ApolloClient } from '@apollo/client';

import { TypeMap, Actions, CartMsg } from '../cart.actions';
import { cartVariantAndId } from '../utils/stateObservables';
import { RemoveItemFromCartInput } from '../queries/__generated__/types';
import { removeItemFromCart, removeItemFromCartVariables } from '../queries/__generated__/removeItemFromCart';
import removeItemMutation from '../queries/removeItemFromCart.graphql';

const name = 'Cart.ItemDelete';
type Action = TypeMap[typeof name];

/**
 * Delete an item from the cart.
 *
 * @param action$
 * @param state$
 * @param deps
 */
export function cartItemDeleteEpic(action$: Observable<any>, state$: Observable<any>, deps: EpicDeps) {
    return action$.pipe(
        ofType<Actions, Action>(name),
        withLatestFrom(cartVariantAndId(state$)),
        mergeMap(([action, [, cartId]]) => {
            const { itemId } = action.payload;
            const payload: RemoveItemFromCartInput = {
                cart_id: String(cartId),
                cart_item_id: itemId,
            };

            const ajax$ = removeItem(payload, deps);

            return ajax$.pipe(
                mergeMap(() => {
                    return of(CartMsg('Cart.ItemDeleteSuccess'), CartMsg('Cart.Refresh', { force: true }));
                }),
                catchableUnauthenticated(({ error }) => {
                    return of(CartMsg('Cart.ItemDeleteError', error));
                }),
            );
        }),
    );
}

function removeItem(input: RemoveItemFromCartInput, deps: EpicDeps) {
    return defer(() =>
        (deps.client as ApolloClient<any>).mutate<removeItemFromCart, removeItemFromCartVariables>({
            mutation: removeItemMutation,
            operationName: 'removeItemFromCart',
            fetchPolicy: 'no-cache',
            variables: {
                input,
            },
        } as any),
    );
}
